var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AmazonS3Connection_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { Connection, ConnectionType } from './connection';
import { amazonS3ConnectionSchemaValidation } from '../validations.generated';
export var AVAILABLE_REGIONS;
(function (AVAILABLE_REGIONS) {
    AVAILABLE_REGIONS["us-east-2"] = "US East (Ohio)";
    AVAILABLE_REGIONS["us-east-1"] = "US East (N. Virginia)";
    AVAILABLE_REGIONS["us-west-1"] = "US West (N. California)";
    AVAILABLE_REGIONS["us-west-2"] = "US West (Oregon)";
    AVAILABLE_REGIONS["af-south-1"] = "Africa (Cape Town)";
    AVAILABLE_REGIONS["ap-east-1"] = "Asia Pacific (Hong Kong)";
    AVAILABLE_REGIONS["ap-south-2"] = "Asia Pacific (Hyderabad)";
    AVAILABLE_REGIONS["ap-southeast-3"] = "Asia Pacific (Jakarta)";
    AVAILABLE_REGIONS["ap-southeast-4"] = "Asia Pacific (Melbourne)";
    AVAILABLE_REGIONS["ap-south-1"] = "Asia Pacific (Mumbai)";
    AVAILABLE_REGIONS["ap-northeast-3"] = "Asia Pacific (Osaka)";
    AVAILABLE_REGIONS["ap-northeast-2"] = "Asia Pacific (Seoul)";
    AVAILABLE_REGIONS["ap-southeast-1"] = "Asia Pacific (Singapore)";
    AVAILABLE_REGIONS["ap-southeast-2"] = "Asia Pacific (Sydney)";
    AVAILABLE_REGIONS["ap-northeast-1"] = "Asia Pacific (Tokyo)";
    AVAILABLE_REGIONS["ca-central-1"] = "Canada (Central)";
    AVAILABLE_REGIONS["eu-central-1"] = "Europe (Frankfurt)";
    AVAILABLE_REGIONS["eu-west-1"] = "Europe (Ireland)";
    AVAILABLE_REGIONS["eu-west-2"] = "Europe (London)";
    AVAILABLE_REGIONS["eu-south-1"] = "Europe (Milan)";
    AVAILABLE_REGIONS["eu-west-3"] = "Europe (Paris)";
    AVAILABLE_REGIONS["eu-south-2"] = "Europe (Spain)";
    AVAILABLE_REGIONS["eu-north-1"] = "Europe (Stockholm)";
    AVAILABLE_REGIONS["eu-central-2"] = "Europe (Zurich)";
    AVAILABLE_REGIONS["me-south-1"] = "Middle East (Bahrain)";
    AVAILABLE_REGIONS["me-central-1"] = "Middle East (UAE)";
    AVAILABLE_REGIONS["sa-east-1"] = "South America (S\u00E3o Paulo)";
    AVAILABLE_REGIONS["us-gov-east-1"] = "AWS GovCloud (US-East)";
    AVAILABLE_REGIONS["us-gov-west-1"] = "AWS GovCloud (US-West)";
})(AVAILABLE_REGIONS || (AVAILABLE_REGIONS = {}));
export const amazonS3ConnectionSchema = {
    $id: 'urn:wisepipe-common-connection:AmazonS3Connection',
    type: 'object',
    properties: {
        bucket: { type: 'string' },
        region: { type: 'string', enum: Object.keys(AVAILABLE_REGIONS) }
    },
    required: ['bucket']
};
let AmazonS3Connection = AmazonS3Connection_1 = class AmazonS3Connection extends Connection {
    constructor(connectionID, name, bucket, region) {
        super(connectionID, ConnectionType.AmazonS3, name);
        this.bucket = bucket;
        if (region)
            this.region = region;
        JSON.validate(this, AmazonS3Connection_1);
    }
};
AmazonS3Connection = AmazonS3Connection_1 = __decorate([
    JsonSchemaV2(amazonS3ConnectionSchema, amazonS3ConnectionSchemaValidation),
    JsonDiscriminatorValue(ConnectionType.AmazonS3)
], AmazonS3Connection);
export { AmazonS3Connection };
//# sourceMappingURL=amazonS3Connection.js.map